<template>
  <el-scrollbar>
    <ul class="address">
      <li v-for="(item,i) in shopListData" :key='i'>
        <div class="name">{{item.name}}</div>
        <div>{{item.tel}}</div>
        <div>{{item.address}}</div>
        <div class="a-icon"><a :href="'tel:'+item.tel"></a></div>
      </li>
    </ul>
  </el-scrollbar>
</template>
<script>
import { getShopList } from '@/views/mobile/PublicApp/apis'
export default {
  data () {
    return {
      shopListData: []
    }
  },
  methods: {
    requestShopList () {
      this.loading = this.$toast.loading()
      let data = new FormData()
      data.append('fromUrl', window.location.href)
      getShopList(data)
        .then(result => {
          this.loading.hide()
          if (result) {
            this.shopListData = result.data.list
          }
        }).catch(error => {
          if (error) {
            this.loading.hide()
          }
        })
    }
  },
  mounted () {
    this.requestShopList()
  },
  created () {
    let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'))
    let shop = window.location.hostname.split('.')[0]
    if (shop === 'szty') {
      document.title = '陶源酒家'
    } else if (userInfo.ext.shopname !== '') {
      document.title = userInfo.ext.shopname
    } else {
      document.title = '香港富临皇宫'
    }
  }
}
</script>
<style lang="less">
.address {
  font-size: 14px;
  li {
    width: 100%;
    overflow: hidden;
    box-sizing: border-box;
    padding: 20px;
    border-bottom: 2px solid #eeeeee;
    position: relative;
    div {
      line-height: 30px;
      font-size: 15px;
      color: #666;
      width: 80%;
    }
    .name {
      line-height: 40px;
      font-size: 20px;
      color: #333;
    }
    .a-icon {
      position: absolute;
      height: 44px;
      width: 44px;
      top: 50%;
      margin-top: -22px;
      right: 20px;
      background: url(../assets/images/dh.png) center no-repeat;
      background-size: contain;
      a {
        display: block;
        float: left;
        width: 100%;
        height: 100%;
        border: none;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        -webkit-tap-highlight-color: transparent;
        outline: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/mobile/PublicApp/components/ShopAddress.vue